export default __webpack_public_path__ + "static/media/commit.f6d3f745.png";